import { Directive, ElementRef, Inject, PLATFORM_ID, AfterViewInit } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Directive({
  selector: 'img',
  standalone: false
})
export class LazyImgDirective implements AfterViewInit {

  constructor(
    private el: ElementRef<HTMLImageElement>,
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  ngAfterViewInit(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return; // Do nothing on server
    }

    const nativeElement = this.el.nativeElement;

    if (!nativeElement) return;

    const supportsLazy = 'loading' in HTMLImageElement.prototype;

    if (supportsLazy) {
      nativeElement.setAttribute('loading', 'lazy');
    } else {
      // fallback to IntersectionObserver
      // e.g. implement lazy-loading manually
    }
  }
}


/* import { Directive, ElementRef, Inject, PLATFORM_ID } from '@angular/core'
import { isPlatformBrowser } from '@angular/common'
@Directive({
    selector: 'img',
    standalone: false
})
export class LazyImgDirective {
  constructor({ nativeElement }: ElementRef<HTMLImageElement>, 
 @Inject(PLATFORM_ID) private platformId: object,) {
    const supports = 'loading' in HTMLImageElement.prototype

    if (isPlatformBrowser(this.platformId)) {
      if (supports) {
        if (typeof nativeElement !== 'undefined') {
          nativeElement?.setAttribute('loading', 'lazy')
        }
      } else {
        // fallback to IntersectionObserver
      }
    }
  }
}
 */